import { UserBonusCardIconProps } from './props';
import styles from './styles.module.scss';
import { useMemo } from 'react';
import { useImageGrid } from '@/hooks/bonus/useImageGrid';
import { Image, ToolTip } from '@starsoft/common/components';

export default function UserBonusCardIcon({
  events,
  isLoading,
}: UserBonusCardIconProps) {
  const { images } = useImageGrid(events);

  const Images: JSX.Element[] = useMemo(
    () =>
      images?.map((event, index) => (
        <ToolTip
          key={`icon-image-${event?.name}-${index}`}
          titleComponent={event?.name}
          visible
        >
          <div className={`${styles[`image-${index}`]}`}>
            <Image
              width={100}
              height={100}
              className={styles.row__image}
              src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}${`/${event?.image?.includes('sportsbook.png') ? '/bonus-types/sportbook-small.png' : `games/150x150${event?.image}`}`}`}
              secondarySkeleton
            />
          </div>
        </ToolTip>
      )),
    [images],
  );

  const Skeletons: JSX.Element[] = useMemo(
    () =>
      Array.from({ length: 9 }).map((_, idx) => (
        <div
          className={`${styles.row__image__skeleton} image-${idx}`}
          key={`icon-skeleton-${idx}`}
        />
      )),
    [],
  );

  if (!isLoading && Images?.length === 0) {
    return null;
  }

  return <div className={styles.row}>{isLoading ? Skeletons : Images}</div>;
}
